var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResolution(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.168 9.49967L21.028 7.20384C20.7588 6.66551 20.2046 6.33301 19.603 6.33301H9.5013C8.63047 6.33301 7.91797 7.04551 7.91797 7.91634V31.6663C7.91797 32.5372 8.63047 33.2497 9.5013 33.2497C10.3721 33.2497 11.0846 32.5372 11.0846 31.6663V22.1663H19.0013L20.1413 24.4622C20.4105 25.0005 20.9646 25.333 21.5505 25.333H30.0846C30.9555 25.333 31.668 24.6205 31.668 23.7497V11.083C31.668 10.2122 30.9555 9.49967 30.0846 9.49967H22.168ZM28.5013 22.1663H22.168L20.5846 18.9997H11.0846V9.49967H19.0013L20.5846 12.6663H28.5013V22.1663Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResolution);
export default __webpack_public_path__ + "static/media/resolution.6ec625bb07fe0feb99d57d7179bd640d.svg";
export { ForwardRef as ReactComponent };